"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchQueryValidationDto = exports.ExportSwingsFiltersDtoValidation = exports.DeleteSwingsDtoValidation = exports.BallTrajectory = exports.ImpactLocation = exports.SwingStatus = exports.DataModes = void 0;
const yup = require("yup");
const app_1 = require("./app");
var DataModes;
(function (DataModes) {
    DataModes["Training"] = "Training";
    DataModes["Viewer"] = "Viewer";
    DataModes["User"] = "User";
})(DataModes = exports.DataModes || (exports.DataModes = {}));
var SwingStatus;
(function (SwingStatus) {
    SwingStatus["Valid"] = "Valid";
    SwingStatus["Invalid"] = "Invalid";
})(SwingStatus = exports.SwingStatus || (exports.SwingStatus = {}));
var ImpactLocation;
(function (ImpactLocation) {
    ImpactLocation["Center"] = "Center";
    ImpactLocation["Toe"] = "Toe";
    ImpactLocation["Heel"] = "Heel";
    ImpactLocation["Crown"] = "Crown";
    ImpactLocation["Sole"] = "Sole";
    ImpactLocation["Misfire"] = "Misfire";
})(ImpactLocation = exports.ImpactLocation || (exports.ImpactLocation = {}));
var BallTrajectory;
(function (BallTrajectory) {
    BallTrajectory["Pull"] = "Pull";
    BallTrajectory["Fade"] = "Fade";
    BallTrajectory["Straight"] = "Straight";
    BallTrajectory["Draw"] = "Draw";
    BallTrajectory["Push"] = "Push";
})(BallTrajectory = exports.BallTrajectory || (exports.BallTrajectory = {}));
exports.DeleteSwingsDtoValidation = yup.object({
    ids: yup.array().of(yup.string()).min(1).required(),
});
exports.ExportSwingsFiltersDtoValidation = yup.object({
    dateFrom: yup.string().notRequired().nullable(),
    dateTo: yup.string().notRequired().nullable(),
    dataModeTraining: yup.boolean().notRequired(),
    dataModeViewer: yup.boolean().notRequired(),
    dataModeUser: yup.boolean().notRequired(),
    algorithmValid: yup.boolean().notRequired(),
    algorithmInvalid: yup.boolean().notRequired(),
    testerValid: yup.boolean().notRequired(),
    testerInvalid: yup.boolean().notRequired(),
    handRight: yup.boolean().notRequired(),
    handLeft: yup.boolean().notRequired(),
    genderMale: yup.boolean().notRequired(),
    genderFemale: yup.boolean().notRequired(),
    skillLevelBeginner: yup.boolean().notRequired(),
    skillLevelIntermediate: yup.boolean().notRequired(),
    skillLevelAdvanced: yup.boolean().notRequired(),
    driver: yup.boolean().notRequired(),
    putter: yup.boolean().notRequired(),
    pull: yup.boolean().notRequired(),
    fade: yup.boolean().notRequired(),
    straight: yup.boolean().notRequired(),
    draw: yup.boolean().notRequired(),
    push: yup.boolean().notRequired(),
});
exports.SearchQueryValidationDto = yup.object({
    page: yup.number(),
    pageSize: yup.number(),
    uploadedByEmail: yup.string(),
    sort: yup.object({
        key: yup.string(),
        order: yup.mixed().oneOf([app_1.SortOrder.ASC, app_1.SortOrder.DESC]),
    }),
});
//# sourceMappingURL=swing.js.map